import HeaderHome from "./components/Header/HeaderHome";
import HeroHome from "./components/Hero/HeroHome";
import '../Homepage/homepage.style.css';
import About from "./components/Main/About/About";
import WhyUs from "./components/Main/WhyUs/WhyUs";
import Footer from "./components/Footer/Footer";
import ReservationForm from "./components/Main/ReservationForm/ReservationForm";

function HomePage() {

    return(
        <div className="HomePage">
            <HeaderHome />
            <HeroHome />
            <About />
            <WhyUs />
            <ReservationForm />
            <Footer />
        </div>
    )
}

export default HomePage;